<template>
  <div>
    <p v-if="payload.distance">{{payload.distance}}</p>

    <!-- Button shown by default -->
    <button class="button is-info" v-if="!showDetails" @click="handleCalculateClick">
      Calculate
    </button>

    <!-- Content shown after button is clicked -->
    <div v-else>
      <div style="min-width: 200px;">
        <p class="py-0 mt-5 bold">Applicant:</p>
        <LocationEditor :payload="{ location: { description: payload.applicant.location }, resource_type: 'Applicant', resource_id: payload.applicant.resource_id }"></LocationEditor>
      </div>
      <div class="">
        <p class="py-0 mt-5 bold">Position:</p>
        <LocationEditor :payload="{ location: { description: location }, resource_type: 'Position', resource_id: payload.position.id }"></LocationEditor>
      </div>
      <div class="mt-3">
        <PreferredWorkRegion :applicantId="payload.applicant.resource_id" v-model="payload.applicant.preferred_work_region" />
      </div>
    </div>
  </div>
</template>
<script>
import LocationEditor from '@/components/LocationEditor'
import PreferredWorkRegion from '@/components/entities/applicant/PreferredWorkRegion'

export default {
  name: 'OfferDistance',
  components: {
    LocationEditor,
    PreferredWorkRegion
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      locationData: undefined,
      showDetails: false
    }
  },
  computed: {
    location () {
      return this.locationData ? this.locationData.description : ''
    }
  },
  methods: {
    handleCalculateClick () {
      this.showDetails = true
      this.getLocation()
    },
    getLocation () {
      this.$network_utils.getResourceLocations({
        current_type: 'Position',
        current_resource_id: this.payload.position.id
      }).then(response => {
        this.locationData = response[0]
      })
    }
  }
}
</script>
